import { render, staticRenderFns } from "./tipsBottomSheet.vue?vue&type=template&id=16bb8dba"
import script from "./tipsBottomSheet.vue?vue&type=script&lang=js"
export * from "./tipsBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./tipsBottomSheet.vue?vue&type=style&index=0&id=16bb8dba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports